export default "__VITE_ASSET__nmn2uRfw__"